import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/UpdateNotes.css';

const UpdateNotesTable = ({ batchId, openUpdateNotesDialogExternally, setOpenUpdateNotesDialogExternally }) => {
  const [notes, setNotes] = useState([]);
  const [note, setNote] = useState({ title: '', description: '', linkOfAttachment: '', status: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [errors, setErrors] = useState({});


  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (openUpdateNotesDialogExternally) {
      setShowDialog(true);
      setOpenUpdateNotesDialogExternally(false); // Reset parent signal
    }
  }, [openUpdateNotesDialogExternally, setOpenUpdateNotesDialogExternally]);
  const handleChange = (e) => {
    setNote({ ...note, [e.target.name]: e.target.value });
    setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
  };

  const validateNote = () => {
    const errors = {};
    if (!note.title?.trim()) errors.title = 'Title is required';
    if (!note.description?.trim()) errors.description = 'Description is required';
    if (!note.status?.trim()) errors.status = 'Status is required';
    return errors;
  };

  const fetchNotes = () => {
    if (!batchId) {
      setNotes([]);
      return;
    }

    axios
      .get(`${API_URL}/api/notes/${batchId}`)
      .then((res) => {
        const response = Array.isArray(res.data) ? res.data : res.data.notes || [];
        setNotes(response);
      })
      .catch((err) => {
        console.error('Error fetching notes:', err);
        setNotes([]);
      });
  };

  useEffect(() => {
    const fetchNotes = async () => {
      if (!batchId) {
        setNotes([]);
        return;
      }

      try {
        const res = await axios.get(`${API_URL}/api/notes/${batchId}`);
        const response = Array.isArray(res.data) ? res.data : res.data.notes || [];
        setNotes(response);
      } catch (err) {
        console.error('Error fetching notes:', err);
        setNotes([]);
      }
    };

    fetchNotes();
  }, [batchId, API_URL]);

  const handleAddOrUpdateNote = async () => {
    const validationErrors = validateNote();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return; // Agar validation fail ho jaye, ruk jao
    }
    if (!note.title && !note.description && !note.linkOfAttachment && !note.status) {
      setShowPopup(true);
      return;
    }


    try {
      const noteData = {
        ...note,
        batchId,
        dateTime: new Date().toISOString(),
      };
      console.log("Submitting note data:", noteData);

      if (isEditing && editingNoteId) {
        await axios.put(`${API_URL}/api/notes/${editingNoteId}`, noteData);
      } else {
        await axios.post(`${API_URL}/api/notes`, noteData);
      }

      fetchNotes();
    } catch (err) {
      console.error('Error saving note:', err);
    }

    setNote({ title: '', description: '', linkOfAttachment: '', status: '' });
    setIsEditing(false);
    setEditingNoteId(null);
    setErrors({});
    setShowDialog(false);
  };


  const handleRowClick = (noteData) => {
    setNote({
      title: noteData.title,
      description: noteData.description,
      linkOfAttachment: noteData.linkOfAttachment,
      status: noteData.status,
    });
    setIsEditing(true);
    setEditingNoteId(noteData._id);
    setShowDialog(true);
  };

  const handleDeleteNote = () => {
    setShowDeleteConfirm(true);
  };

  const confirmDeleteNote = async () => {
    if (!editingNoteId) return;
    try {
      await axios.delete(`${API_URL}/api/notes/${editingNoteId}`);
      fetchNotes();
    } catch (err) {
      console.error('Error deleting note:', err);
    }
    handleCancel();
    setShowDeleteConfirm(false);
  };

  const cancelDelete = () => {
    setShowDeleteConfirm(false);
  };

  const handleCancel = () => {
    setNote({ title: '', description: '', linkOfAttachment: '', status: '' });
    setIsEditing(false);
    setEditingNoteId(null);
    setErrors({});
    setShowDialog(false);
  };

  return (
    <div className="note-container">
      <div className="note-header">
        <h3>Notes</h3>
      </div>

      {showDialog && (
        <div className="dialog-backdrop">
          <div className="dialog-box">
            <button className="cancel-btn" onClick={handleCancel}>
              ×
            </button>
            <h4>{isEditing ? 'Edit Note' : 'Add Note'}</h4>

            <div className="form-group">
              <label htmlFor="title">Title</label>
              <input id="title" name="title" value={note.title} onChange={handleChange} />
              {errors.title && <div className="error-text">{errors.title}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="description">Description</label>
              <input id="description" name="description" value={note.description} onChange={handleChange} />
              {errors.description && <div className="error-text">{errors.description}</div>}
            </div>

            <div className="form-group">
              <label htmlFor="linkOfAttachment">Link of Attachment</label>
              <input id="linkOfAttachment" name="linkOfAttachment" value={note.linkOfAttachment} onChange={handleChange} />
            </div>
            <div className="form-group">
              <label htmlFor="status">Status</label>
              <select
                id='status'
                name='status'
                value={note.status}
                onChange={handleChange}
              >
                <option value="">Select status</option>
                <option value="Enabled">Enabled</option>
                <option value="Disabled">Disabled</option>

              </select>
              {errors.status && <div className="error-text">{errors.status}</div>}
            </div>
            <div className="dialog-actions">
              {isEditing && (
                <button type="button" className="update-delete-btn" onClick={handleDeleteNote}>
                  Delete
                </button>
              )}
              <button type="button" className="update-btn" onClick={handleAddOrUpdateNote}>
                {isEditing ? 'Update Note' : 'Save Note'}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPopup && (
        <div className="popup-backdrop">
          <div className="popup-box">
            <p>Please fill all required fields before adding a note.</p>
            <button onClick={() => setShowPopup(false)}>OK</button>
          </div>
        </div>
      )}

      {showDeleteConfirm && (
        <div className="popup-backdrop">
          <div className="popup-box delete-confirm">
            <p>Are you sure you want to delete this note?</p>
            <div className="delete-confirm-actions">
              <button type='button' className="btn-cancel" onClick={cancelDelete}>Cancel</button>
              <button type='button' className="btn-ok" onClick={confirmDeleteNote}>OK</button>
            </div>
          </div>
        </div>
      )}

      <table className="note-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Description</th>
            <th>Attachment</th>
            <th>status</th>
          </tr>
        </thead>
        <tbody>
          {notes.length === 0 ? (
            <tr>
              <td colSpan="3">No notes added.</td>
            </tr>
          ) : (
            notes.map((item) => (
              <tr key={item._id} onClick={() => handleRowClick(item)}>
                <td>{item.title}</td>
                <td>{item.description}</td>
                <td>{item.linkOfAttachment}</td>
                <td>{item.status}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UpdateNotesTable;
